import React from 'react'
import * as BaseControls from './../common/BaseControls';
import { ISystemBase } from './../common/ISystemBase';
import { SystemBaseList } from './SystemDropDown';
import { SystemBase } from 'library/common/SystemBase';
interface ISystemCheckBox {
}

export default class SystemCustomCheckBox extends SystemBase<ISystemCheckBox>
{
    render() {
        return (
            <>

                <BaseControls.Input
                    type="checkbox"
                    id={this.props.id || ''}
                    name={this.props.name || ''}
                    value={this.state.value}
                    className=""
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    checked={this.state.value}
                    disabled={this.props.disabled}
                />
                <label>{this.props.label}</label>
            </>
        );
    }
}
